import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

/**
 * Displays the application's logo in different variants and provides the correct image URL based on the requested type.
 * @component
 * @selector app-logo
 * @example
 *   <app-logo [logoType]="'icon'"></app-logo>
 *   <app-logo [logoType]="'name'"></app-logo>
 * @input {'icon' | 'name' | undefined} logoType - Selects which logo variant to display. 'icon' returns a small icon SVG, 'name' returns the full logo SVG. If undefined or an unrecognized value is provided, a default fallback image is used.
 * @output none - This component does not emit any output events.
 *
 * Key methods:
 * - get logoUrl(): string - Computed getter that returns the appropriate image path for the current logoType.
 *
 * Lifecycle hooks:
 * - None implemented on this component. Initialization and change handling are sufficiently covered by the logoUrl getter which derives output directly from the input property.
 */
@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './logo.component.scss',
})
export class LogoComponent {
  @Input() logoType: 'icon' | 'name' | undefined;

  get logoUrl(): string {
    switch (this.logoType) {
      case 'icon':
        return '/assets/images/logo/logo-small.svg';
      case 'name':
        return '/assets/images/logo/logo.svg';
      default:
        return '/assets/122.png';
    }
  }
}
